import { ReactNode } from "react";

/** The concept's "Viewed" checkbox for working through long plans. */
export const ViewedCheckbox = ({
  checked,
  onChange,
  children,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
}) => (
  <label className="ml-2 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm text-black/60">
    <input
      type="checkbox"
      className="m-0 accent-[#074EE8]"
      checked={checked}
      onChange={(event) => onChange(event.target.checked)}
    />
    {children}
  </label>
);
